"use client";
import { Input } from "@chakra-ui/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function PostcodeSelector({
  value = "",
  onChange = () => {},
  ...rest
}) {
  const { t } = useTranslation();

  useEffect(() => {
    const script = document.createElement("script");
    script.setAttribute(
      "src",
      "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"
    );
    document.body.appendChild(script);
  }, []);

  const execDaumPostcode = () => {
    // eslint-disable-next-line no-undef
    new daum.Postcode({
      oncomplete: function (data) {
        let addr = "";
        let extraAddr = "";

        if (data.userSelectedType === "R") {
          addr = data.roadAddress;
        } else {
          addr = data.jibunAddress;
        }

        if (data.userSelectedType === "R") {
          if (data.bname !== "" && /[dong|ro|ga]$/g.test(data.bname)) {
            extraAddr += data.bname;
          }

          if (data.buildingName !== "" && data.apartment === "Y") {
            extraAddr +=
              extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
          }
          if (extraAddr !== "") {
            extraAddr = "(" + extraAddr + ")";
          }
        }
        onChange(`${addr} ${extraAddr}`);
      },
    }).open();
  };

  return (
    <Input
      w="full"
      placeholder={t("Select postcode address")}
      onClick={execDaumPostcode}
      value={value}
      readOnly
      cursor="pointer"
      {...rest}
    />
  );
}
